// Mirrors backend/src/avatar-core/constants.js's RARITY_COLORS — kept as a
// small standalone copy since the frontend can't require that CJS module.
export const RARITY_COLORS = {
  common: '#9AA3B2',
  uncommon: '#3DDC84',
  rare: '#29B6FF',
  epic: '#A46CFF',
  legendary: '#FFB454',
  mythic: '#FF4D6D',
};
